export const EXAM_MAP_0 = "인지 + 심층";
export const EXAM_MAP_1 = "심층 -> 인지";
export const EXAM_MAP_2 = "심층";
